/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Sample_PreviewInputs */



/**
* | output |
* | --- |
* | "Sample preview" |
*
* @param {Options_Watermark_Sample_PreviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_sample_preview = /** @type {((inputs?: Options_Watermark_Sample_PreviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Sample_PreviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aperçu d'exemple")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beispielvorschau")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima di esempio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пример предпросмотра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa de ejemplo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("示例预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サンプルプレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नमूना पूर्वावलोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização de exemplo")
	return /** @type {LocalizedString} */ ("Sample preview")
});